import { useCallback, useState } from 'react'
import { useReactiveVar } from '@apollo/client'
import { useTreasury } from 'contracts/treasury/hooks/use-treasury'
import { balanceVar } from 'shared/store/balance-store'
import { Web3Adress } from 'shared/types'
import { showNotificationToast } from 'shared/utils/notify'

export const useClaimSubmit = (
  smartContractAddress: Web3Adress,
  smartContractVersion: number
) => {
  const balance = useReactiveVar(balanceVar)
  const [loading, setLoading] = useState(false)

  const treasury = useTreasury(smartContractAddress, smartContractVersion)

  const handleClaim = useCallback(
    async (amount: string) => {
      if (!treasury?.withdrawAllTokens) return

      const requested = Number(amount)
      const deposited = balance.tokenDeposited
      if (
        !Number.isFinite(requested) ||
        requested <= 0 ||
        Math.abs(requested - deposited) > 0.0001
      ) {
        showNotificationToast({
          title: 'Withdraw full treasury balance',
          description: `Enter exactly ${deposited} USDT (on-chain withdraw is all-or-nothing).`,
          type: 'info'
        })
        return
      }

      setLoading(true)

      showNotificationToast({
        title: 'Approve action in your wallet',
        type: 'info'
      })

      try {
        const tx = await treasury.withdrawAllTokens()

        if (!tx) {
          return
        }

        showNotificationToast({
          title: `${amount} USDT withdrawn`,
          type: 'success'
        })
      } catch (error) {
        console.error(error)
        showNotificationToast({
          title: `Something went wrong`,
          description: 'Please try again',
          type: 'error'
        })
      } finally {
        setLoading(false)
      }
    },
    [treasury, balance.tokenDeposited]
  )

  return { handleClaim, loading }
}
